import router from "./router";
router.beforeEach(async (to, from, next) => {
  const whiteList = ["/login"];
  const hasToken = localStorage.getItem("TOKEN");
  next();
  // if (hasToken) {
  //   if (to.path === "/login") {
  //     next({ path: "/" });
  //   } else {
  //     next();
  //   }
  // } else {
  //   if (whiteList.indexOf(to.path) !== -1) {
  //     next();
  //   } else {
  //     next(`/login`);
  //   }
  // }
});
